import { i18nMark } from 'lingui-react';

const messages = {
  select: i18nMark('Select'),
  selected: i18nMark('Selected'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/ServiceProvidersList/messages.js